module.exports = __webpack_public_path__ + "static/fiji3-d205831501395b48155aa713a099d043.png";